<template lang="pug">
.settings-main-page.flex.justify-center
  Spinner(v-if="fetching")
  div(v-else)
    BriqPanel
      h2 General
      BriqTable
        tr(v-for="field in fields" :key="field")
          td.field-label {{ field }}
          td.field-value {{ businessUnit[field] }}
        tr(v-if="widgetUrl")
          td.field-label Widget url
          td.field-value 
            a(:href="widgetUrl" target="_blank") {{ widgetUrl }}
</template>

<script>
import { parseAxiosException } from '@/helpers/exceptionParser'
import Spinner from '@v/components/Spinner.vue'

export default {
  name: 'SettingsMainPage',
  components: { Spinner },
  data() {
    return {
      businessUnit: null,
      fields: ['Key', 'Name', 'Domain', 'Status'],
      fetching: true,
    }
  },
  computed: {
    widgetUrl() {
      return this.businessUnit?.CurrentWidgetUrl
    },
  },
  async mounted() {
    this.fetching = true
    try {
      const response = await this.$apiClient.get('business-unit/current')
      this.businessUnit = response.data
    } catch (e) {
      const parsed = parseAxiosException(e)
      this.$logError('Error expected to originate from: ', parsed.origin)
      this.$logError(parsed.data)
      this.$notifyError('Something went wrong')
    }
    this.fetching = false
  },
}
</script>

<style scoped lang="stylus">
.settings-main-page
  width 100%
  padding 60px

h2
  margin-bottom 24px

.field-label
  width 300px

.field-value
  width 450px

  a
    color #009BFF

    &:hover
      text-decoration underline
</style>
